exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/**\n * @Author: Zewei\n * @Date:   2018-01-23T14:39:40+08:00\n * @Last modified by:   Zewei\n * @Last modified time: 2018-02-07T16:44:53+08:00\n */\n.ant-row .fixedModalInput {\n  width: 200px;\n  margin-left: 10px;\n}\n.innerEditRoleTable .ant-table-thead {\n  display: none;\n}\n.innerEditRoleTable .innerLabel {\n  margin-right: 6px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js!./src/components/SystemSetting/roleManagementModal.less
// module id = 1608
// module chunks = 0